<div class="outer-container">
  <div class="card table-card" *ngIf="allowed; else notAllowed">
    <div class="restrictions-header" *ngIf="hasRestrictions">
      <suvo-bi-limited-data-banner
        [isTrial]="isTrialing"
        [featureShortCode]="'FINDANDPAGINATE'"
        [tags]="[tileInstance.recipe?.dataSource]"
      ></suvo-bi-limited-data-banner>
    </div>

    <h4 class="margin title" *ngIf="tileInstance.title">
      {{ tileInstance.title }}
    </h4>

    <ng-container *ngIf="hasRequiredConfig; else missingConfig">
      <suvo-bi-data-source-items-table
        *ngIf="options"
        [dataSourceAlias]="dataSourceAlias"
        [filtersChannel]="filtersChannel"
        [options]="options"
        [tableAlias]="tableAlias"
        [sortPrefix]="'data'"
        (itemSelected)="onTableItemSelected($event)"
      >
        <div class="no-data" noDataContent class="d-flex fd-col jc-center ai-center">
          <suvo-core-icon-message title="No Data" message="No data matches these filters.">
          </suvo-core-icon-message>
        </div>
      </suvo-bi-data-source-items-table>
      <div
        class="export-button-container d-flex fd-row jc-center ai-center"
        [ngClass]="{ 'shift-up': tileInstance.showPageControls }"
      >
        <suvo-bi-export-with-filters
          *ngIf="showExportButton"
          [filtersChannel]="filtersChannel"
          [dataSourceAlias]="filtersChannel?.channelName"
          [disabled]="exportDisabled"
        ></suvo-bi-export-with-filters>
      </div>
    </ng-container>
    <ng-template #missingConfig>
      <div class="empty-config d-flex fd-col jc-center ai-center">
        <suvo-core-icon-message
          title="Table preview"
          message="Select a data source and at least one column to see data."
        ></suvo-core-icon-message>
      </div>
    </ng-template>
  </div>

  <ng-template #notAllowed>
    <div class="card not-allowed-message flex-1 d-flex jc-between ai-center">
      <div>
        <b>This feature is available for paid subscribers.</b>
      </div>

      <button color="primary" mat-stroked-button routerLink="/private/my-account/subscription">
        View upgrade options
      </button>
    </div>
  </ng-template>
</div>
